import styled from 'styled-components'
import {
  ColorProps,
  color,
  compose,
  FlexboxProps,
  flexbox,
  LayoutProps,
  layout,
  PositionProps,
  position,
  SpaceProps,
  space,
} from 'styled-system'

export type BoxProps = SpaceProps & LayoutProps & FlexboxProps & ColorProps & PositionProps

const systemProps = compose(space, layout, flexbox, color, position)

// styled-system props that should not be forwarded to the DOM
const styledSystemProps = new Set([
  // Space props
  'm',
  'mt',
  'mr',
  'mb',
  'ml',
  'mx',
  'my',
  'margin',
  'marginTop',
  'marginRight',
  'marginBottom',
  'marginLeft',
  'marginX',
  'marginY',
  'p',
  'pt',
  'pr',
  'pb',
  'pl',
  'px',
  'py',
  'padding',
  'paddingTop',
  'paddingRight',
  'paddingBottom',
  'paddingLeft',
  'paddingX',
  'paddingY',
  // Layout props
  'width',
  'height',
  'minWidth',
  'maxWidth',
  'minHeight',
  'maxHeight',
  'display',
  'size',
  'verticalAlign',
  'overflow',
  'overflowX',
  'overflowY',
  // Flexbox props
  'alignItems',
  'alignContent',
  'justifyItems',
  'justifyContent',
  'flexWrap',
  'flexDirection',
  'flex',
  'flexGrow',
  'flexShrink',
  'flexBasis',
  'justifySelf',
  'alignSelf',
  'order',
  // Color props
  'color',
  'bg',
  'backgroundColor',
  'opacity',
  // Position props
  'position',
  'zIndex',
  'top',
  'right',
  'bottom',
  'left',
])

const shouldForwardProp = (prop: string) => !styledSystemProps.has(prop)

export const Box = styled.div.withConfig({ shouldForwardProp })<BoxProps>`
  ${systemProps}
`
